import React from 'react'

export const TableCell = ({
    obligatorio = false,
    children
}) => {
  return (
    <div className="d-flex w-100 justify-content-end" style={{ color: obligatorio ? '#e88f00': '' }}>
        {children}
    </div>
  )
}
